import * as React from "react";
import { forwardRef } from "react";
const LedHeadlightsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M7.958 18.39a.75.75 0 0 1 0 1.492l-.076.004H3.2a.75.75 0 1 1 0-1.5h4.682l.076.004z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.764 5.586c2.651 0 5.08.771 6.865 2.039s2.979 3.078 2.979 5.142-1.195 3.862-2.976 5.113-4.208 2.006-6.854 2.006h-.047a.75.75 0 0 1-.646-.368c-1.092-1.847-1.736-4.204-1.736-6.754 0-2.577.658-4.958 1.771-6.813l.056-.081a.75.75 0 0 1 .587-.283zm.432 1.507c-.836 1.55-1.346 3.516-1.346 5.671 0 2.129.498 4.073 1.317 5.614 2.217-.07 4.185-.729 5.603-1.726 1.504-1.057 2.338-2.443 2.338-3.886S19.27 9.92 17.76 8.848c-1.414-1.005-3.368-1.677-5.564-1.755z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.923 15.186a.75.75 0 1 1 0 1.5H3.2a.75.75 0 1 1 0-1.5h3.723zM6.79 11.99a.75.75 0 0 1 0 1.492l-.076.004H3.2a.75.75 0 1 1 0-1.5h3.514l.076.004zm.365-3.2a.75.75 0 0 1 0 1.492l-.077.004H3.2a.75.75 0 0 1 0-1.5h3.878l.077.004zm.94-3.2a.75.75 0 0 1 0 1.492l-.076.004H3.2a.751.751 0 0 1 0-1.501h4.818l.076.005z"
}));
const ForwardRef = forwardRef(LedHeadlightsIcon);
export default ForwardRef;